import { EnumOption } from "./enum-option"

export const Gender = {
    Undeclared: 0,
    Male: 1,
    Female: 2,
    Other: 3
}

export const GenderList: EnumOption[] = [
    { value: Gender.Undeclared, label: 'Undeclared' },
    { value: Gender.Male, label: 'Male' },
    { value: Gender.Female, label: 'Female' },
    { value: Gender.Other, label: 'Other' }
];